module.exports = __webpack_public_path__ + "static/img/zeta_template_06.ec28ad0.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/zeta_template_06.png
// module id = VCPa
// module chunks = 1